// /hooks/useDeviceFingerprint.ts
import { useState, useEffect } from 'react';
import { load } from '@fingerprintjs/fingerprintjs';

export function useDeviceFingerprint() {
  const [deviceId, setDeviceId] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getFingerprint = async () => {
      try {
        const fp = await load();
        const result = await fp.get();
        setDeviceId(result.visitorId);
      } catch (error) {
        console.error('Failed to get device fingerprint:', error);
        // 在无法获取指纹时可以设置一个备用ID，但这会降低安全性
        setDeviceId('fingerprint_error'); 
      } finally {
        setIsLoading(false);
      }
    };

    getFingerprint();
  }, []);

  return { deviceId, isLoading };
}
